// extracted by mini-css-extract-plugin
export var errorIcon = "_jg-1";
export var nameLogo = "_jg-0";